import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { endLoading, startLoading } from '../../../actions/loadingAction';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { getVision } from '../../../services/auth';
import { ENUMS, VISIONS } from '../../../utils/constants';
import { onValueChange, validateInputsRequired } from "../../../utils/handleChangeHooks";
import useStateWithPromise from '../../../utils/useEffectUpdate';
import { closeCollapsible, configs, getPathApp, isNullOrEmpty, showMessageToast, showMessageToastCustom, translate } from '../../../utils/util';
import SupplierModal from './SupplierModal';
import ModalUploadBai from './UploadBai/ModalUploadBai';
import SummaryReceipt from './SummaryReceipt';
import { Collapsible, Input } from '../../../components/UI/ComponentsUI';
import ButtonsSubtitle from './ButtonsSubtitle';

const ReceiptSearch = (props) => {
    const [openModal, setOpenModal] = useState(false);
    const [filterSearch, setFilterSearch] = useStateWithPromise({
        mvmNumber: props.mvmFilter || props.location?.state?.mvmNumber || props.filter?.mvmNumber || '',
        journey: props.journey || props.filter?.journey || props.location?.state?.journey || '',
        invoice: props.filter?.invoice || '',
        supplier: props.filter?.supplier || '',
        mvi: props.filter?.mvi || '',
        truckKanban: props.filter?.truckKanban || false,
        pending: true
    })
    const [modalVisible, setModalVisible] = useState(false);
    const [suppliers, setSuppliers] = useState([]);

    useEffect(() => {
        if (props.receipts && props.receipts.length > 0) {
            closeCollapsible('CollapsibleformSearch')
        }
        props.hideLoading();
        if ((!isNullOrEmpty(filterSearch.mvmNumber) || !isNullOrEmpty(filterSearch.journey))
            && ((!isNullOrEmpty(filterSearch.mvi) && filterSearch.truckKanban) || props.location?.state?.forceSearch)) {
            onSearch()
        }
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        if (filterSearch.supplier !== '') {
            search(false)
        }
        // eslint-disable-next-line
    }, [filterSearch.supplier]);

    const getConfig = () => {
        return configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items)
    }

    const onChange = (event) => {
        onValueChange(event, filterSearch, setFilterSearch);
    }

    const onSearchList = () => {
        props.searchList(props.filter, () => {
            props.history.replace({
                state: {
                    multiInvoice: true,
                    truckKanban: filterSearch.truckKanban
                },
                pathname: `${getPathApp(window)}/receipt/V2/receiptStorages`
            });
        });

    }

    const onSearch = () => {
        if (validateInputsRequired("formSearch")) {
            if (!props.user.resource || props.user.resource === '') {
                return showMessageToast({ html: translate('select-resource', 'validations'), classes: 'red' });
            }

            if (isNullOrEmpty(props.user.vision)) {
                return showMessageToast({ html: translate('select-vision', 'validations'), classes: 'red' });
            }
            if ((!props.user.shed || props.user.shed === '') && Boolean(getConfig().shedRequiredPhysicalConfirmation)) {
                return showMessageToast({ html: translate('select-shed', 'validations'), classes: 'red' });
            }

            if ((!props.user.dock || props.user.dock === '') && Boolean(getConfig().dockRequiredPhysicalConfirmation)) {
                return showMessageToast({ html: translate('select-dock', 'validations'), classes: 'red' });
            }

            if (getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD) {
                search(false)
            } else {
                props.verifyDuplication(filterSearch, (res) => {
                    if (res.data.length > 1) {
                        props.hideLoading();
                        setModalVisible(true);
                        setSuppliers(res.data);
                    } else {
                        search()
                    }
                })
            }
        }
    }

    const search = (update) => {
        if (!isNullOrEmpty(filterSearch.mvi)) {
            return props.history.replace({
                state: {
                    mvi: filterSearch.mvi,
                },
                pathname: `/receipt/V2/searchmvi`
            });
        }
        props.showLoading();
        props.setFilter(filterSearch);
        let shed = '';
        if (Boolean(getConfig().shedRequiredPhysicalConfirmation) && !filterSearch.truckKanban) {
            shed = props.sheds ? props.sheds?.find((i) => i.id === props.user.shed)?.code : '';
        }

        if (update) {
            props.updateMvm({
                mvmNumber: filterSearch.mvmNumber,
                journey: filterSearch.journey,
                mvi: filterSearch.mvi,
                searchMvm: true
            }, () => search(false));
        } else {
            let filterDto = {
                mvmNumber: filterSearch.mvmNumber,
                journey: filterSearch.journey,
                supplier: filterSearch.supplier,
                invoice: filterSearch.invoice,
                truckKanban: filterSearch.truckKanban,
                mvi: filterSearch.mvi,
                shed: shed,
                dock: !filterSearch.truckKanban ? props.user.dock : '',
                pending: filterSearch.pending,
                receiptIds: props.receiptIds
            }

            props.searchFilter(filterDto, (response) => {
                if (response.unload && !response.unload.startUnload) {
                    showMessageToastCustom(translate('warning', 'general'), `Iniciar Descarga: ${response.unload.message}`, 8000, 'mdi mdi-alert-circle-outline red-text');
                }
                if (props.onRead) {
                    props.onRead();
                }
                closeCollapsible('CollapsibleformSearch')
                props.hideLoading();
            });
        }
    }

    const handleOnKeyDown = (e) => {
        if (e.key === 'Enter') {
            onSearch();
        }
    }

    const onConfirmModal = (supplier) => {
        setModalVisible(false);
        setFilterSearch({ ...filterSearch, supplier: supplier })
    }

    const onFilterPartNumber = (value) => {
        if (!isNullOrEmpty(value) && value.length > 3) {
            var receipt = props.receipts.find((f) => f.partNumberCode.includes(value))
            if (receipt) {
                var element = document.getElementById(`${receipt.partNumberCode}-${receipt.balance}`);
                if (element) {
                    element.scrollIntoView({
                        behavior: 'smooth'
                    });
                    element.style.backgroundColor = "#2196f3"
                    setTimeout(() => {
                        element.style.backgroundColor = "white"
                    }, 1800);
                }
            }
        }
    }

    const filterBai = () => {
        document.dispatchEvent(new CustomEvent('filterReceiptBai', { detail: { data: props.receipts } }));
    }

    return (
        <div className="container-fluid" style={{ paddingTop: '0px' }}>
            <div className="container" style={{ width: '98%', paddingBlockEnd: filterSearch.truckKanban && '45px' }}>
                <Collapsible
                    simple="true"
                    id="CollapsibleformSearch"
                    header={`Filtros ${!isNullOrEmpty(filterSearch.mvmNumber) ? `MVM ${filterSearch.mvmNumber}` : ''} ${!isNullOrEmpty(filterSearch.journey) ? `Viagem ${filterSearch.journey}` : ''}`}
                    body={
                        <div id="formSearch" className="row" style={{ padding: '0px', width: '95%' }}>

                            <>
                                <div className="input-field no-padding col s5">

                                    {!filterSearch.truckKanban && (getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) ?
                                        <Input
                                            id="invoice"
                                            name="invoice"
                                            required={isNullOrEmpty(filterSearch.journey || filterSearch.mvi)}
                                            placeholder={translate('invoice', 'physical-confirmation')}
                                            type="text"
                                            defaultValue={filterSearch.invoice}
                                            onChange={onChange}
                                            onBlur={onChange}
                                            onKeyDown={(e) => handleOnKeyDown(e)}
                                        /> :
                                        <Input
                                            id="mvmNumber"
                                            name="mvmNumber"
                                            required={isNullOrEmpty(filterSearch.journey || filterSearch.mvi)}
                                            placeholder={translate('mvm', 'physical-confirmation')}
                                            type="text"
                                            numericonly="true"
                                            defaultValue={filterSearch.mvmNumber}
                                            onChange={onChange}
                                            onBlur={onChange}
                                            onKeyDown={(e) => handleOnKeyDown(e)}
                                        />
                                    }
                                </div>
                                <div className="input-field no-padding col s5" >
                                    <Input
                                        id="journey"
                                        name="journey"
                                        required={isNullOrEmpty(filterSearch.mvmNumber || filterSearch.invoice || filterSearch.mvi)}
                                        placeholder={translate('journey', 'physical-confirmation')}
                                        type="text"
                                        numericonly="true"
                                        defaultValue={filterSearch.journey}
                                        onChange={onChange}
                                        onBlur={onChange}
                                        onKeyDown={(e) => handleOnKeyDown(e)}
                                    />
                                </div>
                                <div className="input-field no-padding  col s1" style={{ marginLeft: '-10px' }}>
                                    <button
                                        className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                        type="button"
                                        onClick={() => onSearch()}
                                    >
                                        <i className="Small material-icons">search</i>
                                    </button>
                                    {(getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) &&
                                        props.receiptIds && props.receiptIds.length > 0 &&
                                        <button
                                            className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                            type="button"
                                            onClick={onSearchList}
                                            style={{ margin: '2px' }}
                                        >
                                            <i className="Small material-icons">refresh</i>
                                        </button>
                                    }
                                </div>
                                {!filterSearch.truckKanban && (getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD) &&
                                    <>
                                        <div className="input-field no-padding col s10">
                                            <Input
                                                id="mvi"
                                                name="mvi"
                                                placeholder={translate('mvi', 'physical-confirmation')}
                                                type="text"
                                                defaultValue={filterSearch.mvi}
                                                onChange={onChange}
                                                onBlur={onChange}
                                            />
                                        </div>
                                        {
                                            props.physicalConfirmation?.id && <div className="input-field no-padding  col s1">
                                                <button
                                                    className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                                    type="button"
                                                    onClick={() => setOpenModal(true)}
                                                >
                                                    <i className="Small material-icons">cloud_upload</i>
                                                </button>
                                            </div>
                                        }
                                    </>
                                }
                            </>
                        </div>}
                />
                {
                    props.physicalConfirmation?.id &&
                    <div className="row" style={{ padding: '0px', backgroundColor: 'white', boxShadow: '0 1px 5px 0 rgba(0,0,0,0.2)', borderRadius: '8px' }}>
                        <div className="col m2 s3" style={{ padding: '10px 0px 0px 0px' }}>
                            <SummaryReceipt filter={props.physicalConfirmation?.id} />
                        </div>
                        {
                            !props.filter?.truckKanban &&
                            <>
                                <div className="padding col s3" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                                    <Input
                                        id="partNumber"
                                        name="partNumber"
                                        placeholder="Desenho"
                                        type="text"
                                        onChange={(evt) => onFilterPartNumber(evt.target.value)}
                                    />
                                </div>
                                <div className="padding col s3" style={{ paddingRight: '0px', paddingLeft: '3px' }}>
                                    <Input
                                        id="baiCodeFilter"
                                        name="baiCodeFilter"
                                        placeholder="Bai"
                                        type="text"
                                        onBlur={filterBai}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                filterBai();
                                            }
                                        }}
                                    />
                                </div>
                            </>
                        }
                        <div className="col s3" style={{ padding: '15px 0px 0px 0px' }}>
                            <ButtonsSubtitle />
                            <div style={{ float: !props.filter?.truckKanban ? 'right' : 'left', marginRigth: '3px' }}>
                                <i
                                    className="material-icons"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        filterSearch.pending = filterSearch.pending ? false : true;
                                        setFilterSearch(filterSearch).then(() => {
                                            search(false);
                                        });
                                    }}>
                                    {filterSearch.pending ? 'visibility_off' : 'visibility'}
                                </i>
                            </div>
                            <div style={{ float: !props.filter?.truckKanban ? 'right' : 'left', marginRigth: '3px' }}>
                                <i
                                    className="material-icons"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        props.updateMvm({
                                            mvmNumber: filterSearch.mvmNumber,
                                            journey: filterSearch.journey,
                                            mvi: filterSearch.mvi,
                                            supplier: props.receipts && props.receipts.length > 0 ? props.receipts[0]?.supplier : "",
                                            invoice: props.receipts && props.receipts.length > 0 ? props.receipts[0]?.invoice : "",
                                        }, () => search(false));
                                    }}>sync
                                </i>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <SupplierModal
                open={modalVisible}
                id="confirmDeleteReceipt"
                data={suppliers.map((i) => { return { id: i, text: i }; })}
                onConfirm={(e) => onConfirmModal(e)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
            <ModalUploadBai
                open={openModal}
                id="ModalUploadBai"
                onCancel={() => setOpenModal(false)}
                onClose={() => setOpenModal(false)}
                onConfirm={() => search(false)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        config: state.configReducer.config,
        sheds: state.configReducer.sheds,
        filter: state.physicalConfirmationReducer.filter,
        receiptIds: state.physicalConfirmationReducer.receiptIds,
        physicalConfirmationList: state.physicalConfirmationReducer.physicalConfirmationList,
        physicalConfirmation: state.physicalConfirmationReducer.physicalConfirmation,
        receipts: state.physicalConfirmationReducer.receipts,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        searchFilter: (filterDto, callback) => {
            dispatch(PhysicalConfirmationService.search(filterDto, callback));
        },
        setFilter: (filter) => {
            dispatch(PhysicalConfirmationService.setFilter(filter));
        },
        showLoading: () => {
            dispatch(startLoading());
        },
        hideLoading: () => {
            dispatch(endLoading());
        },
        searchList: (filter, callback) => {
            dispatch(PhysicalConfirmationService.searchList(filter, callback));
        },
        verifyDuplication: (filter, callback) => {
            dispatch(PhysicalConfirmationService.verifyDuplication(filter, callback));
        },
        getByMvi: (mvi, callback) => {
            dispatch(PhysicalConfirmationService.getByMvi(mvi, callback));
        },
        updateMvm: (filter, callback) => {
            dispatch(PhysicalConfirmationService.updateMvm(filter, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReceiptSearch)));